import React, { Component } from 'react';
import { connect } from 'react-redux';
import LocaleComponent from '../../LocaleComponent';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class FilterDropDown extends LocaleComponent {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    const { title, data, filter, onClick } = this.props;
    const { isOpen } = this.state;

    return (
      <ButtonDropdown
        isOpen={isOpen}
        toggle={this.toggle}
      >
        <DropdownToggle caret color="primary">
          {filter === this._all ? title : filter}
        </DropdownToggle>
        <DropdownMenu>
          {
            data.map((item, index) => (
              <DropdownItem
                key={`${title}${index}`}
                onClick={() => {onClick(item)}}>
                <div>
                  { item === filter && <i className="fa fa-check" /> }
                  { item === this._all ? this.localeMessage(this._all) : item }
                </div>
              </DropdownItem>
            ))
          }
        </DropdownMenu>
      </ButtonDropdown>
    )
  }
}

class FilterDropDownContainer extends Component {
  render() {
    return <FilterDropDown {...this.props} />;
  }
}

FilterDropDownContainer = connect(state => ({
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(FilterDropDownContainer);

export default FilterDropDownContainer;



// WEBPACK FOOTER //
// ./src/components/FilterDropDown/FilterDropDown.js